<template>
  <v-dialog v-model="dialog" max-width="480px">
    <v-card>
      <v-card-title class="mx-3">
        {{ $t("Receipt.Fields.memo") }}
        <v-spacer></v-spacer>
        <v-tooltip left>
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on" @click="dialog = false">
              fa-times
            </v-icon>
          </template>
          {{ $t("$vuetify.close") }}
        </v-tooltip>
      </v-card-title>
      <v-divider />
      <v-card-text class="px-4 pt-8">
        <v-textarea v-model="memo" auto-grow outlined />
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn color="secondary" outlined @click="dialog = false">
          {{ $t("$vuetify.close") }}
        </v-btn>
        <v-btn color="primary" depressed @click="$emit('confirm', memo)">
          {{ $t("$vuetify.confirm") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "MemoDialog",

  props: {
    value: Boolean,
    billCheckMemo: String,
  },

  data: () => ({
    dialog: false,
    memo: "",
  }),

  watch: {
    value: {
      immediate: true,
      handler() {
        this.dialog = this.value;
        this.memo = this.billCheckMemo;
      },
    },
    dialog: {
      handler() {
        this.$emit("input", this.dialog);
        if (!this.dialog) this.$emit("close");
      },
    },
  },
};
</script>
